import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ClientSecret } from '@d-environments/secret-key';

if (environment.production) {
  enableProdMode();
}

export const overrideEnv = async () => {
  try {
    let appConfigFile = 'app.config.json';
    let clientSecret = ClientSecret()['dev'];
    if (environment.integration) {
      const response = await fetch(`assets/env.json`);
      const dynamicEnv: any = await response.json();
      appConfigFile = `app.config.${dynamicEnv['environment']}.json`;
      clientSecret = ClientSecret()[`${dynamicEnv['environment']}`];
    }

    const response = await fetch(`assets/${appConfigFile}`);
    const dynamicEnv: any = await response.json();
    for (const key in dynamicEnv) {
      if (Object.prototype.hasOwnProperty.call(dynamicEnv, key)) {
        // @ts-ignore
        const targetProp = environment[key];
        if (targetProp !== undefined) {
          // @ts-ignore
          environment[key] = dynamicEnv[key];
        }
      }
    }
    environment.sso.clientSecret = clientSecret;
  } catch (error) {
    console.error(error);
  }
  return environment;
};

overrideEnv().then(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
